import { zipWith } from 'lodash';

import TIK from 'constants/time/timeIntervalKind.const';
import asArray from 'utils/arrays/asArray.util';
import sortArray from 'utils/arrays/sortedArray.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import logger from 'utils/logger.util';

const L = logger('generateScores'); // eslint-disable-line no-unused-vars

const ORDER = Object.freeze({
  [TIK.monthToDate]: 0,
  [TIK.monthLast]: 1,
  [TIK.monthThis]: 2,
  [TIK.monthNext]: 3,
  [TIK.weekToDate]: 4,
  [TIK.weekLast]: 5,
  [TIK.weekThis]: 6,
  [TIK.weekNext]: 7,
  [TIK.dayYester]: 8,
  [TIK.dayToday]: 9,
  [TIK.dayMorrow]: 10,
});

const UNKNOWN = Number.MIN_SAFE_INTEGER;

const compare = (a, b) => {
  const idA = a?.stylistId ?? UNKNOWN;
  const idB = b?.stylistId ?? UNKNOWN;

  const sign = Math.sign(idB - idA);

  // not 0, and maybe even not NaN
  if (sign) return sign;

  const orderA = ORDER[a.kind] ?? UNKNOWN;
  const orderB = ORDER[b.kind] ?? UNKNOWN;

  return Math.sign(orderA - orderB);
};

const merge = (a, b) => ({ ...(a ?? void 1), ...(b ?? void 1) });

const remap = (item) => {
  const ok = item?.value?.is?.ok;
  const json = item?.value?.json ?? {};

  const bgn = json.bgn || item?.bgn;
  const end = json.end || item?.end;

  const isBusiness = fromAnyToBool(!json.stylists);
  const isForecast = fromAnyToBool(json.isForecast);

  // NOTE: just mask the "value" field out, it's the BE result object in full
  const extra = { bgn, end, ok, isBusiness, isForecast, value: void 1 };

  return isBusiness ? { ...item, ...extra, performances: asArray(json.performances) } : asArray(json.stylists).map((stylist) => ({ ...item, ...stylist, ...extra }));
};

const generateScores = (options) => {
  const zipped = zipWith(asArray(options?.options), asArray(options?.settled), merge);
  const remapped = zipped.flatMap(remap);

  return sortArray(compare, remapped);
};

export default generateScores;
